import React, { useState, useRef, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Footer from '../components/Footer';
import SEOHead from '../seo/SEOHead';
import { PAGE_SEO } from '../seo/seoConfig';

import logo1 from '../assets/logos/CSIR.png'
import logo2 from '../assets/logos/Gail.png'
import logo3 from '../assets/logos/HPC.png'
import logo4 from '../assets/logos/IOAGPL.png'
import logo5 from '../assets/logos/IOC.png'
import logo6 from '../assets/logos/adani.png'
import logo7 from '../assets/logos/assam.png'
import logo8 from '../assets/logos/goa.png'
import logo9 from '../assets/logos/meshpower.avif'
import logo10 from '../assets/logos/oryx.png'
import logo11 from '../assets/logos/rajasthan.png'
import logo12 from '../assets/logos/wlpga.jpg'
import img from '../assets/image1.jpg'
import img2 from '../assets/image2.jpg'
import img1 from '../assets/image1.jpg'

const ClientsPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [scrollOffset, setScrollOffset] = useState(0);
  const thumbnailTrackRef = useRef(null);

   const logos = [
    logo1, logo2, logo3, logo4, logo5, logo6,
    logo7, logo8, logo9, logo10, logo11, logo12
  ];

  const minSwipeDistance = 50;

  const testimonials = [
    {
      name: "Arun Kumar",
      location: "Kolkata",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      images: [
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=360&fit=crop",
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&h=360&fit=crop",
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=600&h=360&fit=crop"
      ],
      thumbnail: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face"
    },
    {
      name: "Shalini Sharma",
      location: "Mumbai",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      images: [
        img,
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600&h=360&fit=crop",
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=600&h=360&fit=crop"
      ],
      thumbnail: img
    },
    {
      name: "Sharron smith",
      location: "Ghana",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      images: [
       img1,
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&h=360&fit=crop",
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=600&h=360&fit=crop"
      ],
      thumbnail: img1
    },
    {
      name: "Priya Singh",
      location: "Bangalore",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      images: [
        img2,
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600&h=360&fit=crop",
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=600&h=360&fit=crop"
      ],
      thumbnail: img2
    }
  ];

  // Update scroll position when slide changes
  useEffect(() => {
    if (thumbnailTrackRef.current) {
      const itemWidth = 260 + 16; // thumbnail width + gap
      const containerWidth = thumbnailTrackRef.current.parentElement.offsetWidth;
      const totalWidth = itemWidth * testimonials.length;
      
      // Calculate offset to center the active slide
      let newOffset = -(currentSlide * itemWidth) + (containerWidth / 2) - (260 / 2);
      
      // Limit offset to prevent scrolling beyond bounds
      const maxOffset = 0;
      const minOffset = -(totalWidth - containerWidth);
      newOffset = Math.max(minOffset, Math.min(maxOffset, newOffset));
      
      setScrollOffset(newOffset);
    }
  }, [currentSlide, testimonials.length]);

  const nextImage = () => {
    setCurrentImageIndex((prev) => 
      (prev + 1) % testimonials[currentSlide].images.length
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => 
      (prev - 1 + testimonials[currentSlide].images.length) % testimonials[currentSlide].images.length
    );
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    setCurrentImageIndex(0);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setCurrentImageIndex(0);
  };

  const handleThumbnailClick = (index) => {
    setCurrentSlide(index);
    setCurrentImageIndex(0);
  };

  // Touch handlers for testimonial carousel
  const onTouchStart = (e) => {
    setTouchEnd(0);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextSlide();
    }
    if (isRightSwipe) {
      prevSlide();
    }
  };

  // Touch handlers for image carousel
  const onImageTouchStart = (e) => {
    setTouchEnd(0);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onImageTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onImageTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextImage();
    }
    if (isRightSwipe) {
      prevImage();
    }
  };

  return (
    <>
      <SEOHead
        title={PAGE_SEO.clients.title}
        description={PAGE_SEO.clients.description}
        keywords={PAGE_SEO.clients.keywords}
        canonical={PAGE_SEO.clients.canonical}
        ogImage={PAGE_SEO.clients.ogImage}
      />
      <div className="client-testimonials-page">
      <style>{`
        :root {
          --max-width: 1200px;
        }

        .client-testimonials-page {
          background: #ffffff;
          min-height: 100vh;
          padding: 25px 0;
          font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .testimonials-main-container {
          max-width: var(--max-width);
          margin: 0 auto;
          padding: 0 24px;
        }

        .testimonials-section-heading {
          font-size: 2.5rem;
          font-weight: 500;
          color: #1a1a1a;
          text-align: left;
          margin-bottom: 32px;
          line-height: 1.2;
        }

        .trusted-brands-wrapper {
          margin-bottom: 64px;
        }

        .brands-marquee-container {
          width: 100%;
          overflow: hidden;
          position: relative;
          background: #ffffff;
          padding: 32px 0;
        }

        .brands-marquee-container::before,
        .brands-marquee-container::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          width: 150px;
          z-index: 2;
          pointer-events: none;
        }

        .brands-marquee-container::before {
         left: 0;
  background: linear-gradient(to right, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 30%, rgba(255, 255, 255, 0) 100%);
}


        .brands-marquee-container::after {
         right: 0;
  background: linear-gradient(to left, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 30%, rgba(255, 255, 255, 0) 100%);
        }

        .brands-marquee-slider {
          display: flex;
          animation: brandScroll 30s linear infinite;
        }

        @keyframes brandScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        .brands-marquee-track {
          display: flex;
          align-items: center;
          justify-content: space-around;
          min-width: 100%;
          flex-shrink: 0;
          gap: 60px;
        }

        .brand-logo-item {
          height: 60px;
          width: auto;
          object-fit: contain;
          opacity: 0.7;
          transition: opacity 0.3s ease;
          flex-shrink: 0;
        }

        .brand-logo-item:hover {
          opacity: 1;
        }

        .video-testimonials-wrapper {
          margin-top: 48px;
          max-width: var(--max-width);
          margin-left: auto;
          margin-right: auto;
        }

        .testimonial-display-container {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          gap: 32px;
          margin-bottom: 48px;
          max-width: var(--max-width);
          margin-left: auto;
          margin-right: auto;
        }

        .testimonial-text-content {
          text-align: left;
          max-width: 600px;
        }

        .testimonial-person-name {
          font-size: 1.5rem;
          font-weight: 600;
          color: #F97316;
          margin-bottom: 8px;
        }

        .testimonial-person-location {
          font-size: 1.125rem;
          color: #6B7280;
          font-style: italic;
          margin-bottom: 16px;
        }

        .testimonial-quote-text {
          font-size: 1rem;
          color: #374151;
          line-height: 1.6;
        }

        .main-image-carousel-container {
          position: relative;
          width: 600px;
          height: 360px;
          background: #f3f4f6;
          border-radius: 8px;
          overflow: hidden;
          flex-shrink: 0;
          touch-action: pan-y;
        }

        .carousel-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .image-carousel-nav-button {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.9);
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.3s ease;
          z-index: 10;
        }

        .image-carousel-nav-button:hover {
          background: rgba(255, 255, 255, 1);
        }

        .image-carousel-prev {
          left: 16px;
        }

        .image-carousel-next {
          right: 16px;
        }

        .carousel-indicators {
          position: absolute;
          bottom: 16px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 8px;
          z-index: 10;
        }

        .carousel-indicator-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          cursor: pointer;
          transition: background 0.3s ease;
          border: none;
        }

        .carousel-indicator-dot.active {
          background: rgba(255, 255, 255, 1);
          width: 24px;
          border-radius: 5px;
        }

        .testimonial-carousel-wrapper {
          position: relative;
          padding: 0 16px;
          max-width: var(--max-width);
          margin: 0 auto;
          touch-action: pan-y;
          overflow: hidden;
        }

        .carousel-navigation-button {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #ffffff;
          border: 2px solid #e5e7eb;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          transition: background 0.3s ease;
        }

        .carousel-navigation-button:hover {
          background: #f9fafb;
        }

        .carousel-prev-button {
          left: -16px;
        }

        .carousel-next-button {
          right: -16px;
        }

        .carousel-thumbnails-track {
          display: flex;
          gap: 16px;
          transition: transform 0.5s ease;
          will-change: transform;
        }

        .carousel-thumbnail-item {
          flex-shrink: 0;
          width: 260px;
          height: 160px;
          position: relative;
          cursor: pointer;
          border-radius: 8px;
          overflow: hidden;
          border: 2px solid transparent;
          transition: border-color 0.3s ease;
        }

        .carousel-thumbnail-item.active {
          border-color: #F97316;
        }

        .carousel-thumbnail-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .carousel-thumbnail-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.7);
          color: white;
          padding: 8px;
        }

        .carousel-thumbnail-name {
          font-weight: 600;
          font-size: 0.75rem;
          margin-bottom: 2px;
        }

        .carousel-thumbnail-location {
          font-size: 0.625rem;
          opacity: 0.8;
        }

        .carousel-dots-navigation {
          display: flex;
          justify-content: center;
          gap: 8px;
          margin-top: 24px;
          max-width: var(--max-width);
          margin-left: auto;
          margin-right: auto;
        }

        .carousel-dot-indicator {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #d1d5db;
          cursor: pointer;
          transition: background 0.3s ease;
          border: none;
        }

        .carousel-dot-indicator.active {
          background: #F97316;
        }

        @media (max-width: 768px) {
          .client-testimonials-page {
            padding: 32px 0;
          }
            .brands-marquee-container::before,
        .brands-marquee-container::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          width: 50px;
          z-index: 2;
          pointer-events: none;
        }
          .testimonials-main-container {
            padding: 0 16px;
          }

          .testimonials-section-heading {
            font-size: 2rem;
            margin-bottom: 16px;
          }

          .trusted-brands-wrapper {
            margin-bottom: 48px;
          }

          .brands-marquee-container {
            margin-left: -16px;
            margin-right: -16px;
            width: calc(100% + 32px);
          }

          .brands-marquee-track {
            gap: 40px;
          }

          .brand-logo-item {
            height: 70px;
          }

          .testimonial-display-container {
            flex-direction: column;
            text-align: center;
            gap: 24px;
          }
          
          .main-image-carousel-container {
            width: 100%;
            max-width: 400px;
            height: 250px;
          }
          
          .carousel-thumbnail-item {
            width: 150px;
            height: 90px;
          }

          .carousel-navigation-button {
            display: none;
          }
        }
      `}</style>
  
      <div className="testimonials-main-container">
        <h2 className="testimonials-section-heading">Trusted by Leading Brands</h2>
      </div>
      
      <div className="trusted-brands-wrapper">
        <div className="brands-marquee-container">
          <div className="brands-marquee-slider">
            <div className="brands-marquee-track">
              {logos.map((logo, index) => (
                <img 
                  key={index} 
                  src={logo} 
                  alt={`Client logo ${index + 1}`} 
                  className="brand-logo-item" 
                />
              ))}
            </div>
            <div className="brands-marquee-track">
              {logos.map((logo, index) => (
                <img 
                  key={`duplicate-${index}`} 
                  src={logo} 
                  alt={`Client logo ${index + 1}`} 
                  className="brand-logo-item" 
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="testimonials-main-container">
        <div className="video-testimonials-wrapper">
          <h2 className="testimonials-section-heading">Client Testimonials</h2>
          
          <div className="testimonial-display-container">
            <div className="testimonial-text-content">
              <div className="testimonial-person-name">{testimonials[currentSlide].name}</div>
              <div className="testimonial-person-location">{testimonials[currentSlide].location}</div>
              <div className="testimonial-quote-text">{testimonials[currentSlide].text}</div>
            </div>
            
            <div 
              className="main-image-carousel-container"
              onTouchStart={onImageTouchStart}
              onTouchMove={onImageTouchMove}
              onTouchEnd={onImageTouchEnd}
            >
              <img
                src={testimonials[currentSlide].images[currentImageIndex]}
                alt={`${testimonials[currentSlide].name} testimonial ${currentImageIndex + 1}`}
                className="carousel-image"
              />
              
              <button 
                className="image-carousel-nav-button image-carousel-prev" 
                onClick={prevImage}
              >
                <ChevronLeft size={24} color="#333" />
              </button>
              
              <button 
                className="image-carousel-nav-button image-carousel-next" 
                onClick={nextImage}
              >
                <ChevronRight size={24} color="#333" />
              </button>

              <div className="carousel-indicators">
                {testimonials[currentSlide].images.map((_, index) => (
                  <button
                    key={index}
                    className={`carousel-indicator-dot ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                  />
                ))}
              </div>
            </div>
          </div>

          <div 
            className="testimonial-carousel-wrapper"
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            <button className="carousel-navigation-button carousel-prev-button" onClick={prevSlide}>
              <ChevronLeft size={20} color="#6B7280" />
            </button>
            
            <div 
              ref={thumbnailTrackRef}
              className="carousel-thumbnails-track"
              style={{ transform: `translateX(${scrollOffset}px)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className={`carousel-thumbnail-item ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => handleThumbnailClick(index)}
                >
                  <img
                    src={testimonial.thumbnail}
                    alt={testimonial.name}
                    className="carousel-thumbnail-image"
                  />
                  <div className="carousel-thumbnail-overlay">
                    <div className="carousel-thumbnail-name">{testimonial.name}</div>
                    <div className="carousel-thumbnail-location">{testimonial.location}</div>
                  </div>
                </div>
              ))}
            </div>
            
            <button className="carousel-navigation-button carousel-next-button" onClick={nextSlide}>
              <ChevronRight size={20} color="#6B7280" />
            </button>
          </div>

          <div className="carousel-dots-navigation">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`carousel-dot-indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => handleThumbnailClick(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default ClientsPage;